import { render } from "./Shopping.vue?vue&type=template&id=47d66ce5"
import script from "./Shopping.vue?vue&type=script&lang=js"
export * from "./Shopping.vue?vue&type=script&lang=js"

import "./Shopping.vue?vue&type=style&index=0&id=47d66ce5&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__